

import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import Home from './Pages/Home';
import Support from './Pages/Support';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />
  },
  {
    path: "/suporte-clinica-do-esporte",
    element: <Support />
  }
])

function App() {
  return (
    <RouterProvider router={router} />
  );
}

export default App;
